<template>
    <div class="container-fluid">
        <Breadcrumb title="Add PMTA Server" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit PMTA Server #' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card" v-show="id">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="checkSoftware"><i
                                    class="fas fa-check-square"></i>
                                Check software readiness on PMTA
                                <div v-if="waiting === 'softwareReadiness'"
                                     class="spinner-grow spinner-grow-sm" role="status"></div>
                            </button>
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="checkConfigDates"><i
                                    class="fas fa-check-square"></i>
                                Check config dates on PMTA
                                <div v-if="waiting === 'configDates'"
                                     class="spinner-grow spinner-grow-sm" role="status"></div>
                            </button>
                            <button type="button" class="btn btn-warning btn-rounded mr-2 mb-2"
                                    @click="uploadConfig"><i
                                    class="fas fa-upload"></i>
                                Upload PMTA config to server
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card" v-show="false">
                    <div class="card-body">
                        <div id="readinnesHtml">
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm">
                                    <thead>
                                    <tr>
                                        <th>Service</th>
                                        <th>Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-bind:class="{'table-danger': !service.ready}"
                                        v-for="(service, index) in readinnes" :key="index">
                                        <td>{{service.service}}</td>
                                        <td>{{service.ready ? 'ready' : 'not ready'}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div id="configsDatesHtml" v-show="false">
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm">
                                    <thead>
                                    <tr>
                                        <th>Service</th>
                                        <th>Config date</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-bind:class="{'table-danger': !service.date}"
                                        v-for="(service, index) in configsDates" :key="index">
                                        <td>{{service.service}}</td>
                                        <td>{{service.date ? moment.utc(service.date.toString()).format('D/M/YYYY H:mm')
                                            : '-'}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-if="!id">
                    <div class="card-body">
                        <div class="form-group" v-if="uploadingFiles.length">
                            <h5>Now uploading files:</h5>
                            <div v-for="(list, index) in uploadingFiles" :key="index">
                                <h3 class="mb-1 mt-3" style="font-size:18px;">
                                    {{list.label}}
                                    <span style="float:right;">{{list.completion}}</span>
                                </h3>
                                <div class="progress-bar bg-info" role="progressbar"
                                     v-bind:style="{width: list.completion, height: '3px'}"
                                     aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="uploadCard1View = true">
                                <i class="fas fa-upload"></i>
                                Upload Servers
                            </button>
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="uploadCard2View = true">
                                <i class="fas fa-upload"></i>
                                Upload Servers With Relays
                            </button>
                        </div>
                    </div>
                </div>
                <transition>
                    <div class="card" v-if="!id" v-show="uploadCard1View" :key="$route.fullPath">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="uploadCard1View = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div>
                                <div class="form-group">
                                    <h4>Upload a list of PMTA Servers</h4>
                                    <small class="form-text text-muted mt-0">
                                        <br/>
                                        Header is required. Field separator is colon. <br/>
                                        Acceptable optional fields: encryption, ownerId, withoutConfig.<br/>
                                        Example:<br/>
                                        name:serverIp:httpPort:sshPort:sshLogin:httpAccessList:smtpPort:withoutConfig<br/>
                                        My_New_Pmta:12.31.14.51:80:2200:root:12.23.34.45:25:1<br/>
                                        Test_Pmta:21.13.41.15:80:2200:root:21.32.43.54:25:1<br/>
                                    </small>
                                </div>
                                <div class="form-group text-left" v-if="this.$store.getters.isAdmin">
                                    <label>Select Server Owner(or use 'ownerId' field in csv)</label>
                                    <treeselect placeholder="Select Server"
                                                v-model="owner"
                                                :multiple="false"
                                                :options="userList"
                                                :load-options="loadUserList"
                                                value-format="object"
                                    />
                                </div>
                                <div class="form-group text-left">
                                    <input type="file" id="servers" accept="text/csv" class="w-100"/>
                                </div>
                                <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                        @click="listUpload(true)">
                                    <i class="fas fa-upload"></i>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition>
                    <div class="card" v-if="!id" v-show="uploadCard2View" :key="$route.fullPath">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="uploadCard2View = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div>
                                <div class="form-group">
                                    <h4>Upload a list of PMTA Servers with Relays</h4>
                                    <small class="form-text text-muted mt-0">
                                        <br/>
                                        Header is required. Field separator is colon. <br/>
                                        Acceptable optional fields for server: encryption, withoutConfig.<br/>
                                        Acceptable optional fields for relay: active, withoutVmta. <br/>
                                        Server owner = relay group owner. <br/>
                                        Example:<br/>
                                        name:serverIp:httpPort:sshPort:sshLogin:httpAccessList:smtpPort:relayGroupId:relayHost:relayIp:senderEmail<br/>
                                        My_New_Pmta:12.31.14.51:80:2200:root:12.23.34.45:25:23:relay.com:12.31.14.51:noreply@relay.com<br/>
                                        Test_Pmta:21.13.41.15:80:2200:root:21.32.43.54:25:hoesender.live:21.13.41.15:info@hoesender.live<br/>
                                    </small>
                                </div>
                                <div class="form-group text-left">
                                    <input type="file" id="servers_with_relays" accept="text/csv" class="w-100"/>
                                </div>
                                <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                        @click="listUpload(false)">
                                    <i class="fas fa-upload"></i>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="card">
                    <div class="card-body">
                        <PmtaServerForm :id="id" @hidePreloader="hidePreloader"></PmtaServerForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import PmtaServerForm from './forms/PmtaServerForm';
    import Breadcrumb from '../components/Breadcrumb';
    import PmtaServerService from '../services/PmtaServerService';
    import Swal from 'sweetalert2';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../services/UserService';
    import UploadFileService from '../services/UploadFileService';
    import {FileType} from '../constants';
    import config from '../config';
    import {mapGetters} from 'vuex';

    export default {
        name: 'PmtaServer',
        props: ['id'],
        components: {
            Preloader, PmtaServerForm, Breadcrumb, Treeselect
        },
        data() {
            return {
                loading: false,
                waiting: null,
                readinnes: [],
                configsDates: [],
                uploadCard1View: false,
                uploadCard2View: false,
                userList: null,
                uploadingFiles: [],
                owner: null,
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            } else {
                this.getUploadingFiles();
                this.listUploadProgress();
            }
        },
        computed: {
            ...mapGetters({mercureListen: 'listen'})
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            },
            async checkSoftware() {
                this.waiting = 'softwareReadiness';
                let swalHtml = '';
                await PmtaServerService.checkSoftware(this.id).then(response => {
                    this.waiting = null;
                    if (response.status === 200) {
                        this.readinnes = response.data.readinnes;
                    } else {
                        swalHtml = (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                    }
                }).catch(error => {
                    this.waiting = null;
                    swalHtml = error;
                });
                await Swal({
                    title: 'Software readiness on PMTA server:',
                    width: '50%',
                    html: swalHtml === '' ? document.getElementById('readinnesHtml').innerHTML : swalHtml,
                    confirmButtonText: 'Close',
                });
            },
            async checkConfigDates() {
                this.waiting = 'configDates';
                let swalHtml = '';
                await PmtaServerService.checkConfigDates(this.id).then(response => {
                    this.waiting = null;
                    if (response.status === 200) {
                        this.configsDates = response.data.configsDates;
                    } else {
                        swalHtml = (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                    }
                }).catch(error => {
                    this.waiting = null;
                    swalHtml = error;
                });
                await Swal({
                    title: 'Dates of configuration files on PMTA server:',
                    width: '50%',
                    html: swalHtml === '' ? document.getElementById('configsDatesHtml').innerHTML : swalHtml,
                    confirmButtonText: 'Close',
                });
            },
            uploadConfig() {
                Swal({
                    type: 'warning',
                    title: 'Are you sure you want to upload config?',
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PmtaServerService.uploadConfig(this.id)
                            .catch(error => {
                                Swal.showValidationMessage(
                                    'Error: ' + error.response.data.error[0]
                                )
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value.status === 200) {
                        Swal({
                                type: 'success',
                                title: 'Upload command successfully accepted.',
                            }
                        )
                    }
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            getUploadingFiles() {
                UploadFileService.getFiles(FileType['PMTA_SERVERS_SIMPLE']).then(response => {
                    if (response.status === 200) {
                        this.uploadingFiles = this.uploadingFiles.concat(response.data['hydra:member'].map(file => {
                            return {id: file.id, label: file.originalName, completion: '0%'}
                        }));
                    }
                });
                UploadFileService.getFiles(FileType['PMTA_SERVERS_WITH_RELAYS']).then(response => {
                    if (response.status === 200) {
                        this.uploadingFiles = this.uploadingFiles.concat(response.data['hydra:member'].map(file => {
                            return {id: file.id, label: file.originalName, completion: '0%'}
                        }));
                    }
                });
            },
            listUploadProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadPmtaServersProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadPmtaServersProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadPmtaServersProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadPmtaServersProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data.fileId !== undefined) {
                        let index = this.uploadingFiles.findIndex(file => file.id === data.fileId);
                        if (index < 0) {
                            return;
                        } else {
                            this.uploadingFiles[index].completion = parseInt(data.completion) + '%';
                        }
                        if (data.error !== undefined) {
                            this.$snotify.error('File ' + this.uploadingFiles[index].label + ' processing error: ' + data.error);
                            this.uploadingFiles.splice(index, 1);
                            return;
                        }
                        if (100 === parseInt(data.completion)) {
                            this.$snotify.success('File ' + this.uploadingFiles[index].label + ' processing completed! Created ' + data.createdCount + ' servers.');
                            this.uploadingFiles.splice(index, 1);
                        }
                    }
                }
            },
            listUpload(simple) {
                let data = new FormData();
                let file = simple ? document.getElementById('servers').files[0] : document.getElementById('servers_with_relays').files[0];
                data.append('servers', file);
                if (this.owner) {
                    data.append('ownerId', this.owner.id);
                }
                data.append('type', simple ? 'simple' : 'withRelay');
                PmtaServerService.uploadServers(data).then(response => {
                    if (response.status === 200) {
                        Swal({
                            type: 'success',
                            title: 'File is accepted for processing',
                            text: 'It will take some time to process the data, please wait.'
                        });
                        this.getUploadingFiles();
                        this.uploadCard1View = false;
                        this.uploadCard2View = false;
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Error',
                            text: response.data.error !== undefined ? response.data.error : 'Some error occurred.'
                        })
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
